export default {
  name: 'marking--atkKM',
  apiService: 'shoes',
  apiPath: '/admin/marking_code',
};